import { render, staticRenderFns } from "./warnList.vue?vue&type=template&id=bb174f30&scoped=true"
import script from "./warnList.vue?vue&type=script&lang=js"
export * from "./warnList.vue?vue&type=script&lang=js"
import style0 from "./warnList.vue?vue&type=style&index=0&id=bb174f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb174f30",
  null
  
)

export default component.exports